import { createMachine } from 'xstate'
export const TicketMachine =
/** @xstate-layout N4IgpgJg5mDOIC5QBUCWBjA1mALgYgAcBXWACwXQHsA7AM1SgG0AGAXUVAMtlR1Ro4gAHogBMATgDMogHQB2AGwBWAIyKFo0QA5xKgDQgAnmOZzJMhSoAsWycy1KlG0QF8XBtFlwzkASQDCANIAosgA+gCyAIL+ABK+AHLBMr7UvJ7Y+GAATtmU2TIEADYAhji0+QC2PhiZPgEh4dFxicmp6bW4CKjUAG6U6GX81Cyso4JcPHwCSMKI4gpyMpIqolaKWswKWnIGxggq9uLLClY2uotWym4enTj1QaGRMfFJKWk4Gbh4NBSkYF4IAg+F4cONZpNeMNBCIEAslis1hstjs9ogVJJVDIMZslMxJJZmOI5K53CAvvc-I8mi9Wu8OqC8EJYDgymAZCVaDgcgAKFR45jMACUeApD0azxab3anzu4M43ChM1AsPhy1W622KN2RnRqi02Oslm0uhUCgWN3Jd3FT2ar2SAAUogBxYJhYIAJQ9AHkPXgAEYlLDISi+CBFMDykCQ6bUGGIJRyYkyUxyKziK7icRE0Rog7rWQqYniLRWVaYrSly1iqkSu10p2u91e31Mllsjlc3l8Spgb1EHD+ErUdBgIoimsNW20t6Nt2en0eqMx6GzWGJ5Op9OZ7PiXO6g5KTQWEtbZjp0ySdPV6216dSx0ut0AdR9CWdYTiwSCYUSAaDmAhmGEbLoqsbxggSibEsW4Zuau77vsZpyAaRZJlmChbFYjhWDeoI2jSD4yHOYSvt676frE36BL+CRtqy3Kdty2Q8j2fYDkOI5jhOt5ToR9rEU+pFvh+X4-okoFTKuKoJkmMFyGmcFZjmeZqNoJ7QUoxIEswpK3Phd78XSYkhAAImEhm0WEDregAMr4eCSUqcZruiVwqCmGiSAp6w6JIe55mW5jMFppxSAS-JWHpVoGXxkoCSZwTmZZiTWXZDmMCo7AQmB0lzPmlieaI3lpihUgBQeZoaBYRoSPiJVKHhdSWfWbyJclcWpTZ9mOaI2UKlJyr5UaHlbMVPllf5iHot5CiGlcWiiAokiYqIRZNd4LUzskJkWXFsRRAAam6HrBBEiSmY5bATLlQ2wqIpijc4hwoXIKhaNYeb+cwywrUWawliSOwbZScWtTtVE-pZB3HWEp3nQkl2Zf10a3S5MkIA9b1FWtpg7O9n0HpoP0CrpH0rSFCggwR8XGZDNHQ0dJ1nRdvUoyud0mNjY2469BNWHmWgKHNQsLboQXSCo1NbURu0pQkFnxAAyp+tkAKpK8gnpXezaMQSscg-YoqhnCSxKrHm5oeZqZaZkoUWSNLYPbTIcudQryDK6rGta36yM3YN6P5QbRvKNYBbm9NCBC3N+IYo40FZpWTvUrTs5CREau2X4Dq2W6Jl-tQYBCDgSvcgQTnga5CDeZWMgfcVpZlvijg6khgpWCcZb22HhvMFLZKTqn4OCU2mfZ74uf5-Tf6wGOAI4AgDolDwYAjNdOWB-rS2d1c-mWPyGhWJIqn4ksagOJWJa6KIiYp3WLskePOd55R1F-oGwahuGkYbwNzkQQ3PJRSO4VIHjMAaTQpxxqHHEKoOQ997wCSflnF+09350WZAxdknJmKsVQL2fsOBbI9DACUbIPFYrD0fhnVBk9X4FwSJXPK65oIph8kpBCqllo-XNEmSWqwtLeUQUZdOTZLLw1ZkXEuZcwAVz-qjLe1dRBmDmoid6OwoK2zzGmcwotyb2G0CsERadHziLipIxG-4v7AV-rrJRGMgHsJAfBMB+wHpzQ1LoLMKFHAqMdoPXi1CiIkQkSzKxWCOy4O7AQ9ixDSHkMoc1Z2IShJhIRqZZhnNIJsNgqAiq7inAWABgsK8TgszRSHg-EJ3pNZ7WpHgHIeQCjFDKBUbI1QqlIIbLU8Ihluh9AGEMGgowslB1hGWIW8gVqqFrqtAWlUHoGksNhTQ4t94mJHjZOphkfjUD+ACTAPRgRygURzcZiBJlzTMJiDEKF5l5ntgiIkJI0zpjxMDQJVDqnIN6fUxo9EoldhYvyQUwpRRBJ+T0nZfExkQSudM25cyjwLKQrfTx1gtLnkMYmLQmyXaWV2n+OF1criLBkGtV6S0oJwK0F9bMMgswlmWphB63krj4qIoS+mtFHJZQDgA0lwsliUp2NSnQUFHk2HkDvRMcdQXiE5cgoSSs1b+H8MEJWKslaJGdAwnlH8AJAR-iSxxclnHblcQUxA7KZDpgqWYd6WZVBKobCqtVGqtVhB1e+fV1FeWRMYtElibEiGcVHOOCF3zuliLdKq9VmrtW6r9eJJhZy9bVycXkq1UcopKBTGC-E2wVn8kal85JwTlVNnjZ6lWz96HoNTdYwC38QLpocflLNHD8lRyUNIClO9DHaHsOsV1sbvUesTZEOhU835NsDTg4F+DCEcWHBGpJm0UlVrjZOr19bZ1ErTfYwVZrNzdpzY8xaMrTili0keFYA99IVqhW8V04QogJGQB6XwH6wj2U1ngMglAADuCBhw4GyKgYcprO1IhTFIEKcgnC4nEF9YWKZirYRZQsTCjgx3JCVsEPO-g-DkTCKZKIyAog6wFVXDGId5Bh1NhIN6UcFiyD7SofkigSQSCvPh+oERgjejVuEN9tEABi3o8AQBoOyHo-RsA1GjaI5IfghMibE08RIUmBn9EGLGUZ7aT35WwqYO1fbKynBWpIW9qkoLBS4069MyhfHUyiKZBG1knwyA8wjQFQal2kw3fcPzXUfNhaPbRlh8x-IyB7jodYaggpt3RKWcwBIbArSWofWw1NfCmVfnOQDgx9kgkyAgI53BMAwdhLYeQRJTB4hLMhDMqkuOQOwotbyjhi2VOtAVorT4SvDhOaCSr-BYA1f5ZvEz911jxbNFxkK8JML4lUv5JYOgzRWHsImZQS18uFbdMV2ApWxsVaq1NxgfVovZN2yTKQKEzh4y0qpTYshbMfXsIoWzckjtDddCNsrdwJvVcYJIY9dHTNFONBeJz2xEx5geliM4a09zYT3BiXC5bvCDZOz5xIvhkA0dm9D+66lC34iWmyhSqkkyyGKgsbMGh7CnCprj+4+PvOuhkOJ2yUQABCRGZNyZkApygSmxTc7nHzp4Avhe2T00MwzbBavogxCmXEhifG6C2KpJOFKNCYT3A4XQ1MFy+n+U8Q9AXF14NDaurikaxSW49Nb8Ih71c1wehYFY0h1j+ScCfA8jhRovPTN9gkKELctnd9y-1hqbEmuM+TsQOwLCVnxKb6QEg4GCymQ4bYmxvGJjLG4Mk1BKAQDgIICkd2LlwjzAAWjWAWwUZVyyYlswEp9m7K2tAbxBQ21yG6nBsFcPj7Wfr2tNIKRYhskwCZlPXsnMWEBIc7ihVY4-SwaCkBtvE9dTh93GqWJDAmSJu6H6S4+xwFqHCWWWRYqk952psCFEKdhTy95is+mNZiL4Ikc6NEiQN+GMag1UEgGIS05+KECg3C3kXc7Oy032WwAm7UHuVk3Uvg4Bw0ZoP0EgC+hiZgCwqKM0R+oswsFwlgX2GBPKjMsMlipkeBsIaknccc9g3WKiPG9KJMWkGwpYhwhw2E9B-q8sisvgKs-g6smsnorB6epwjK3kIU2Efa1OIe+wDgW2J+y0R4qg2kl+tCE8B6M8CQChNcx8M+iG7kAolgSgeYFwFgTgt86YmgH0UERh5iqczBFhaw-IjKR4Y+V4NODhlUyYTKe4t8xIosiqnONMWyfyhkFh-kdgfuJY2gCk1mqW0cpYFK+8-csCjW-WKmpiNMh6FhZwRStm2kFM+8vau28WWkosaYtg24XhO6CaXqPqeqjaoB5ha+2S9sC26W9UTyOwCBB4BI+aikWY3kS0tm5oHRE6XRdaM6Ka-RlRug5gSYWKu2QMZoYR+w96dqig6we8Ty1w8RMsAk4mH6X6P6Cs-6yAWx2w8W5oLmueGYRxNqyg8gs+8xqBSx1xW6dIhGxGpGCsFGVGfhl8FmgMR4hwgohM+whuukf00EXGK0cRfeoMA+bw6mwmomYQ4mOm3olRyE7x545oeIUU62lUsyJw1miwpeFo8RkWPOwQFhjq8Ghsaky09qUc-0xw-ct8faCwKK6B7Jnm4WvOkW3JSYvJ-cJIApFSyO-cc0qgOWCcQCJRdQMuT4FhSOlUmEu8OguGd6u2OOuJKQx2nJKQCQxOFhhwPxBwSYP018wspYukPc1pf+eOdpsu-OQuRGzpS0jKb0MRH0cChwtm72SGWuUUVm32pSAOBOvOpk5EXJgxjeeeywvWvkZgmGORRYmwzhcCV4yJ0BeK8RbuWBFROZ8KjRy0MBgecCy0p81UosRIH0agWRpIbgQAA */
createMachine({
  entry: 'setCtxConfigure',
  id: 'Ticket',

  states: {
    TICKET_MACHINE: {
      initial: 'InitTicket',
      states: {
        InitTicket: {
          invoke: {
            src: 'getTicketInfo',
            onError: [
              {
                target: 'PAGE_ERROR',
                actions: 'errorGetTicketSlack'
              }
            ]
          },
          after: {
            15000: {
              target: 'TIMEOUT_GET_INFO',
              actions: []
            }
          },
          on: {
            'on:checked:ticket': {
              target: 'CHECKED_TICKET_IN_POLI',
              actions: 'setCtxDetailTicket'
            }
          }
        },

        PAGE_ERROR: {
          entry: ['setCtxErrorPage'],

          on: {
            backToIdle: {
              target: '#Ticket'
            }
          },

          after: {
            timeOutCancel: {
              target: '#Ticket',
              actions: [],
              internal: false
            }
          }
        },

        PAGE_WRONG_CHECK_IN: {
          entry: 'setCtxPageWrongCheckIn',

          on: {
            backToIdle: '#Ticket'
          },

          after: {
            timeOutCancel: {
              target: '#Ticket',
              actions: []
            }
          }
        },

        CHECKED_TICKET_IN_POLI: {
          entry: ['setCtxArrReduceThisCluster'],
          always: [
            {
              target: 'CHECK_TICKET_HAVE_REMIND',
              cond: 'isHaveThisCluster',
              description: 'apakah ticket mempunyai cluster'
            },
            {
              target: 'PAGE_WRONG_CHECK_IN',
              cond: 'ticketHaveCluster'
            },
            {
              target: 'PAGE_ERROR'
            }
          ]
        },

        CHECK_TICKET_HAVE_REMIND: {
          entry: [
            'setCtxTicketLateNotThisCluster',
            'setCtxTicketHasCheckInThisCluster'
          ],
          always: [
            {
              target: 'TICKET_CHECK_IN',
              cond: 'isAllTicketAllreadyCheckIn',
              actions: 'setCtxTypeWarning',
              description: 'cek ticket yang hanya mempunyai list check in'
            },
            {
              target: 'PAGE_TICKET_REMIND',
              cond: 'isHaveTicketRemind',
              description: 'cek tiket apakah mempunyai ticket remind'
            },
            {
              target: 'CHECK_TICKET_IN_THIS_CLUSTER'
            }
          ]
        },

        CHECK_TICKET_IN_THIS_CLUSTER: {
          always: [
            {
              target: 'POST_TICKET',
              cond: 'isHaveTicketOnlyOnePoli'
            },
            {
              target: 'PAGE_MULTIPLE_CHECKIN'
            }
          ],

          entry: 'editCtxArrOnlyArriveCluster'
        },

        PAGE_MULTIPLE_CHECKIN: {
          entry: 'setCtxPageMultipleCheckIn',

          on: {
            nextStep: {
              target: 'POST_TICKET',
              actions: 'setCtxLoadingPage'
            },

            'select:Pasien': 'SELECTION_DATA',
            backToIdle: '#Ticket'
          },

          after: {
            timeOutLinear: {
              target: '#Ticket',
              actions: []
            }
          }
        },

        PAGE_TICKET_REMIND: {
          entry: 'setCtxPageRemind',
          exit: 'deleteCtxArrTicketNotThisCluster',
          on: {
            nextStep: {
              target: 'CHECK_TICKET_IN_THIS_CLUSTER'
            },
            backToIdle: {
              target: '#Ticket'
            }
          },
          after: {
            timeOutLinear: {
              target: '#Ticket',
              actions: [],
              internal: false
            }
          }
        },

        POST_TICKET: {
          exit: 'setCtxTypeSuccess',
          invoke: {
            src: 'postCheckInTicket',
            onError: [
              {
                target: 'PAGE_ERROR',
                actions: 'errorSlackCheckIn'
              }
            ]
          },
          after: {
            15000: {
              target: 'TIMEOUT_GET_INFO',
              actions: []
            }
          },
          on: {
            'on:checkin:ticket': 'TICKET_CHECK_IN'
          }
        },

        TICKET_CHECK_IN: {
          always: [
            {
              target: 'GET_ANTRIAN_LIST',
              cond: 'isTicketCheckInOnlyOne'
            },
            {
              target: 'PAGE_SUCCESS_MULTIPLE_CHECK_IN'
            }
          ],

          entry: 'editCtxOnlyCheckInThisCluster'
        },

        PAGE_SUCCESS_SINGLE_CHECK_IN: {
          entry: 'setCtxSinglePageCheckIn',

          on: {
            backToIdle: '#Ticket'
          },

          after: {
            timeOutCancel: {
              target: '#Ticket',
              actions: []
            }
          }
        },

        PAGE_SUCCESS_MULTIPLE_CHECK_IN: {
          entry: 'setCtxMultiplePageCheckIn',

          on: {
            backToIdle: '#Ticket'
          },

          after: {
            timeOutCancel: {
              target: '#Ticket',
              actions: []
            }
          }
        },

        GET_ANTRIAN_LIST: {
          invoke: {
            src: 'getInfoAntrian'
          },

          on: {
            'show:antrian': {
              target: 'PAGE_SUCCESS_SINGLE_CHECK_IN',
              actions: 'setCtxTicketCheckIn'
            }
          }
        },

        SELECTION_DATA: {
          entry: 'editCtxCheckInData',
          always: 'PAGE_MULTIPLE_CHECKIN'
        },

        TIMEOUT_GET_INFO: {
          invoke: {
            src: 'timeoutGetInfo',
            onDone: 'PAGE_ERROR'
          }
        }
      }
    },

    ADMIN_PAGE: {
      initial: 'ADMIN',
      states: {
        ADMIN: {
          after: {
            5000: {
              target: '#Ticket',
              actions: []
            }
          }
        }
      }
    },

    IDLE_PAGE: {
      entry: [
        'setCtxIdlePage',
        'deleteCtxArrTicketNotThisCluster',
        'deleteCtxObjTicketDetail'
      ],

      on: {
        'scan:ticket:kiosk': [{
          target: 'ERROR_TICKET_CHECK_IN',
          cond: 'isTicketAppointment'
        }, {
          target: 'TICKET_MACHINE',
          cond: 'isPasienTicket',
          actions: ['setCtxLoadingPage', 'setCtxStrGeneratedId']
        }, {
          target: 'ADMIN_PAGE',
          cond: 'isAdminTicket',
          actions: 'setCtxAdminPage'
        }, {
          target: '#Ticket',
          actions: 'showToastError'
        }]
      },

      states: {
        INIT: {
          always: {
            target: 'GET_LABEL',
            cond: 'isLabel'
          }
        },

        GET_LABEL: {
          invoke: {
            src: 'getLabelBadge',
            onDone: {
              target: 'DONE',
              actions: 'setCtxAllLabels'
            }
          }
        },

        DONE: {}
      },

      initial: 'INIT'
    },

    ERROR_TICKET_CHECK_IN: {
      entry: 'setCtxErrorPageAppointment',

      after: {
        timeOutCancel: '#Ticket'
      },

      on: {
        backToIdle: '#Ticket'
      }
    }
  },

  on: {
    'push:config': {
      target: '#Ticket',
      internal: true,
      actions: 'setCtxConfigure'
    }
  },

  initial: 'IDLE_PAGE'
})

// context
// config : {
//   "screen": "kioskCheckIn",
//   "cluster": {
//     "id": "",
//     "nama": "",
//     "info": "",
//     "rs": ""
//   },
//   "delay": {
//     "buttonLinearCancelDelay": 2,
//     "buttonLinearCancelProgress": 10,
//     "buttonLinearCancelAfter": 2,
//     "timeOutCancel": 30
//   }
// }
